import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {StyledContainer} from './styles';

const {line1, line2, line3} =
	translations['pt-br'].privateFlow.myHospitalization.generalOrientations.cards.nutrition;

export const Nutrition = () => (
	<StyledContainer>
		<Typography variant="body1">{line1}</Typography>
		<Typography variant="body1">{line2}</Typography>
		<Typography variant="body1">{line3}</Typography>
	</StyledContainer>
);
